const FolderIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="6" fill="#6C5DD3" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.48329 5.62668H9.50663C10.7366 5.62668 11.3366 6.28335 11.3333 7.63002V9.25335C11.3333 10.54 10.54 11.3333 9.24996 11.3333H6.74663C5.46329 11.3333 4.66663 10.54 4.66663 9.25002V6.74668C4.66663 5.36668 5.27996 4.66668 6.48996 4.66668H7.01663C7.32696 4.66335 7.61663 4.80668 7.80663 5.05002L8.09996 5.44002C8.19329 5.55668 8.33329 5.62668 8.48329 5.62668ZM6.45663 9.09657H9.54329C9.67996 9.09657 9.78996 8.98324 9.78996 8.84657C9.78996 8.70657 9.67996 8.59657 9.54329 8.59657H6.45663C6.31663 8.59657 6.20663 8.70657 6.20663 8.84657C6.20663 8.98324 6.31663 9.09657 6.45663 9.09657Z"
      fill="white"
    />
  </svg>
)

export default FolderIcon
